import Dropzone from '../../../node_modules/dropzone/index';

(function ($) {
    $.widget('ca.caKioskPreview', {
        _create: function () {
            var self = this;

            self.kioskPreviewLink();
        },

        kioskPreviewLink: function () {
            var self = this;

            let intervalId = setInterval(function () {
                if (document.querySelector('#memberPortalSettingsGlobal .dz-clickable')) {
                    self.eventsForKioskPreview();
                    clearTimeout(intervalId);
                }
            }, 2000);
        },

        eventsForKioskPreview: function () {
            var self = this;

            let welcomeMessage = document.querySelector('#kiosk-general-settings #welcome_screen_message');
            let colorInputField = document.querySelector('#primaryColor');
            let colorPallete = document.querySelector('.colorpicker.dropdown-menu');
            let dropZoneInstance = Dropzone.forElement('#clubLogo');
            self.onDropZoneLogoUpdate(dropZoneInstance);

            if (welcomeMessage) {
                self.onWelcomeMessageChange(welcomeMessage);
            }
            self.onChangeColorInput(colorInputField);
            self.onMouseMove(colorPallete, colorInputField);
            self.setPreviewColorToElement(colorInputField.value, self.colorLuminance(colorInputField.value));
        },

        onMouseMove: function (colorPallete, colorInputField) {
            var self = this;

            ['mousemove', 'mousedown'].forEach((item) => {
                colorPallete.on(item, function () {
                    const hexColorCode = colorInputField.value.padEnd(7, '0');
                    self.setPreviewColorToElement(hexColorCode, self.colorLuminance(hexColorCode));
                });
            });
        },

        setPreviewColorToElement: function (primaryColor, secondaryColor) {
            document.querySelector('.brandingExample.kiosk .get-started').style.backgroundColor = primaryColor;
            document.querySelector('.brandingExample.kiosk').style.background = `linear-gradient(to top, ${primaryColor}, ${secondaryColor})`;
        },

        onChangeColorInput: function (colorInputField) {
            var self = this;

            ['input', 'blur'].forEach((item) => {
                colorInputField.on(item, function (e) {
                    const hexColorCode = e.target.value.padEnd(7, '0');
                    self.setPreviewColorToElement(hexColorCode, self.colorLuminance(hexColorCode));
                });
            });
        },

        onWelcomeMessageChange: function (welcomeMessage) {
            welcomeMessage.on('blur', function (e) {
                document.querySelector('.brandingExample.kiosk .welcome-message').innerHTML = e.target.value;
            });
        },

        onDropZoneLogoUpdate: function (dropZoneInstance) {
            const logoImageElement = document.querySelector('.kiosk-body #logo');
            const duplicateLogoImageElement = document.querySelector('.kiosk-body #duplicateLogo');

            dropZoneInstance.on('complete', function () {
                const logoSource = document.querySelector('#clubLogo img').src;
                const newLogoImage = document.createElement('img');
                const kioskBody = document.querySelector('.kiosk-body');

                if (duplicateLogoImageElement) {
                    // logoImageElement.setAttribute('src', logoSource);
                    duplicateLogoImageElement.setAttribute('src', logoSource);
                } else if (logoImageElement) {
                    logoImageElement.classList.add('kiosk-logo');
                }

                newLogoImage.src = logoSource;
                newLogoImage.id = 'duplicateLogo';
                newLogoImage.alt = 'Club Logo';

                kioskBody.prepend(newLogoImage);

                document.querySelector('#clubLogoContainer .deleteUploadedFile').on('click', function (e) {
                    document.querySelector('.kiosk-body #duplicateLogo').remove();
                    if (logoImageElement) {
                        logoImageElement.classList.remove('kiosk-logo');
                    }
                });
            });
        },

        colorLuminance: function (primaryColor) {
            primaryColor = primaryColor.replace(/[^0-9a-f]/gi, '');
            primaryColor.padEnd(6, '0');
            let resultingHexCode = '#', c;

            for (let x = 0; x < 3; x++) {
                c = parseInt(primaryColor.substr(x * 2, 2), 16);
                c = Math.round(Math.min(Math.max(0, c + c * (-0.5)), 255)).toString(16);
                resultingHexCode += `${('00' + c).substr(c.length)}`;
            }

            return resultingHexCode;
        }
    });
})(jQuery);